import { render } from "./StockInOut.vue?vue&type=template&id=a99ab042&scoped=true"
import script from "./StockInOut.vue?vue&type=script&lang=js"
export * from "./StockInOut.vue?vue&type=script&lang=js"

import "./StockInOut.vue?vue&type=style&index=0&id=a99ab042&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a99ab042"]])

export default __exports__